import { useContext } from "react";
import logo from "../../assets/images/logo.svg";
import { AppContext } from "contexts/AppContext";
import { ThemeMode } from "enums/theme";
import { useTheme } from "@mui/material";

const Logo = () => {
  const theme = useTheme();

  return (
      <svg version="1.1" viewBox="0 0 2048 586" width="150px" xmlns="http://www.w3.org/2000/svg">
        <path transform="translate(1588,79)"
              d="m0 0h21l17 2 21 5 19 8 14 8 10 8 12 11 10 13 9 15 8 19 5 21 2 18v21l-3 22-6 21-7 16-10 16-13 15-13 11-14 9-17 8-21 6-11 2-11 1h-23l-22-3-20-6-16-7-16-10-12-11-10-10-9-13-10-19-6-18-3-15-1-8v-36l3-18 5-18 11-23 12-16 8-9 11-9 14-9 14-7 21-7 17-3zm8 51-17 2-15 5-13 7-12 10-9 12-7 14-4 14-2 13v20l3 18 6 16 6 10 9 11 11 9 16 8 16 4 7 1h16l17-3 15-6 13-9 10-10 9-14 5-12 4-18v-30l-4-18-6-14-7-10-9-10-12-9-16-7-13-3z"
              fill="#054195"/>
        <path transform="translate(1231,83)"
              d="m0 0h110l14 2 16 5 15 8 11 10 7 10 6 12 4 16 1 7v20l-3 14-4 10-7 10-9 9-13 8-13 5-7 1 10 16 29 43 22 33 19 28v1h-66l-10-16-14-24-32-54-14-23-16-1v118h-56zm56 46v64h44l12-3 8-4 7-8 3-7 1-5v-9l-2-9-4-6-5-5-7-4-9-3-8-1z"
              fill="#054295"/>
        <path transform="translate(1064,79)"
              d="m0 0h20l22 3 20 6 16 8 14 11 11 13 8 16 3 10v4l-51 13-3-1-4-12-6-10-8-7-11-5-8-2h-21l-12 3-10 6-6 8-2 6v13l5 8 7 6 12 6 24 8 26 8 21 8 17 9 11 9 8 8 8 14 4 13 1 6v19l-4 18-8 16-11 12-8 7-12 7-16 6-19 4-10 1h-24l-17-2-19-5-17-7-11-7-11-9-8-9-7-11-5-11-4-15v-2l15-4 40-9h3l4 15 6 11 8 8 16 8 9 2h23l13-4 8-6 4-5 3-8v-15l-5-10-9-8-14-7-60-20-15-7-11-6-11-9-7-8-8-16-3-16v-12l3-16 6-15 8-11 9-9 14-9 14-6 15-4z"
              fill="#054295"/>
        <path transform="translate(1787,83)" d="m0 0h156v49h-100v61h88v48h-88v61h100v49h-156z" fill="#054195"/>
        <path transform="translate(683,83)" d="m0 0h56v219h84v49h-140z" fill="#054195"/>
        <path transform="translate(217,60)"
              d="m0 0 6 1 24 14 26 15 24 14 26 15 24 14 26 15 18 11v61l-12-6-24-14-52-30-9-6-72-42-5 1-28 16-24 14-28 16-78 45v-3l14-25 14-24 14-25 9-15 52-30 24-14 28-16z"
              fill="#0F81C8"/>
        <path transform="translate(220,136)"
              d="m0 0 5 1 49 28-4 4-25 14-17 10-52 30-27 16-22 13-23 14h-2v187l-4-5-15-27-14-24-20-35v-125l5-4 26-15 101-59 24-14z"
              fill="#144CA3"/>
        <path transform="translate(470,143)"
              d="m0 0 3 3 13 23 14 24 16 28 7 12v127l-9 6-144 84-19 11-10-5-24-14-17-10-1-2 25-14 24-14 27-15 17-10 21-13 23-14 26-16 7-4z"
              fill="#069ADE"/>
        <path transform="translate(166,244)"
              d="m0 0h2l1 200 25 14 24 14 22 12 24 14 22 12 24 14 16 9 1 2h-105l-27-15-28-16-25-14-24-14-3-2v-200l9-6 25-14z"
              fill="#134CA3"/>
        <path transform="translate(246,61)"
              d="m0 0h105l23 13 28 16 25 14 24 14 6 4v200l-9 6-42 24h-2v-201l-6-2-28-16-25-14-49-28-25-14-24-14z"
              fill="#069ADE"/>
        <path transform="translate(181,376)"
              d="m0 0 5 2 25 14 17 10 26 15 24 14 52 30 22 13 5-1 52-30 27-16 28-16 48-28 1 2-13 23-14 24-16 28-8 13-9 6-28 16-26 15-24 14-21 12-4-1-22-13-26-15-27-16-28-16-48-28-17-10-1-1z"
              fill="#0F81C8"/>
        <path transform="translate(866,83)" d="m0 0h55v268h-55z" fill="#054195"/>
        <path transform="translate(181,376)"
              d="m0 0 5 2 25 14 17 10 26 15 24 14 52 30 4 4v20l-1 11v22l1 4h-6l-26-15-27-16-28-16-48-28-17-10-1-1z"
              fill="#054195"/>
        <path transform="translate(246,61)"
              d="m0 0h105l23 13 28 16 8 5 1 2v252l-5 3h-2v-201l-6-2-28-16-25-14-49-28-25-14-24-14z" fill="#0F82C9"/>
        <path transform="translate(205,67)"
              d="m0 0 5 1v53l1 3-1 3-26 15-28 16-97 56v-3l14-25 14-24 14-25 9-15 52-30 24-14z" fill="#1966B1"/>
        <path transform="translate(138,260)" d="m0 0 5 1v225l-1 2-5-1-22-13v-200l9-6z" fill="#054396"/>
        <path transform="translate(220,136)"
              d="m0 0 5 1 49 28-4 4-25 14-17 10-52 30-22 13-2-1v-55l-4-2 16-9 27-16 26-15z" fill="#0F81C8"/>
        <path transform="translate(430,107)" d="m0 0 5 2 21 12 1 1v200l-9 6-17 10-2-1 4-2-1-225z" fill="#02A7EA"/>
        <path transform="translate(75,221)" d="m0 0h3l1 2v183l-1 2h-3l-15-27-11-19v-125l5-4z" fill="#054497"/>
        <path transform="translate(397,374)"
              d="m0 0h4v42l1 14-4 4-23 13-24 14-10-5-24-14-17-10-1-2 25-14 24-14 27-15 17-10z" fill="#1966B1"/>
        <path transform="translate(472,328)"
              d="m0 0 2 2v57l-4 5-23 13-27 16-17 10-2-1-1-16v-36l1-4-3-1 20-12 26-16 25-15h3z" fill="#0F81C8"/>
        <path transform="translate(317,116)" d="m0 0 14 8 25 14 22 13 13 8v61l-12-6-24-14-26-15-12-7 1-5v-54z"
              fill="#02A6E9"/>
        <path transform="translate(263,423)"
              d="m0 0 10 5 24 14 26 15 10 6 1 6v16l-1 11v22l1 4h-6l-26-15-27-16-16-9 4-2z" fill="#1966B1"/>
        <path transform="translate(496,188)" d="m0 0 4 5 16 28 7 12v127l-9 6-17 10-1-2 1-180z" fill="#02A7EA"/>
        <path transform="translate(213,470)" d="m0 0 5 2 22 12 24 14 22 12 24 14 16 9 1 2h-105l-13-7 4-1-1-8v-42z"
              fill="#0F81C8"/>
        <path transform="translate(136,107)" d="m0 0 4 1 1 2v51l-2 7-28 16-52 30v-3l14-25 14-24 14-25 9-15z"
              fill="#134CA3"/>
        <path transform="translate(151,178)" d="m0 0 2 2v55l-4 4-22 13-20 12-2-4v-54l-3-1 45-26z" fill="#1966B1"/>
        <path transform="translate(512,383)" d="m0 0 1 2-13 23-14 24-16 28-8 13-9 6-13 7 1-3v-56l-3 1v-2l26-15 24-14z"
              fill="#069ADE"/>
        <path transform="translate(247,62)" d="m0 0h94l1 2-1 49-5 1-17-10-25-14-21-12-26-15z" fill="#1966B1"/>
        <path transform="translate(223,400)" d="m0 0 12 6 24 14 5 5v55l-1 1-7-1-26-15-9-5 2-2 1-9v-41z" fill="#134CA3"/>
        <path transform="translate(317,116)" d="m0 0 14 8 19 11 3 4v54l-3 3-5-2-25-14-3-2 1-5v-54z" fill="#069ADE"/>
        <path transform="translate(350,401)" d="m0 0 5 2v54l-4 4-10-5-24-14-17-10-1-2 25-14 24-14z" fill="#134CA3"/>
        <path transform="translate(163,91)" d="m0 0 4 1 2 4v48l-2 8-27 15v-57l-2-4 17-10z" fill="#1E59A7"/>
        <path transform="translate(263,423)" d="m0 0 10 5 17 10 2 7v50l-2 2-7-1-22-13-2-2 4-1z" fill="#1E59A7"/>
        <path transform="translate(186,454)" d="m0 0 15 8 12 7 1 3-1 9v46l-7-1-23-13 2-4v-54z" fill="#1966B1"/>
        <path transform="translate(225,138)" d="m0 0 5 2 25 14 19 11-4 4-25 14-17 10-4 2 1-7z" fill="#069ADE"/>
        <path transform="translate(121,194)" d="m0 0h2l1 4v53 3l-17 10-2-4v-54l-3-1z" fill="#1E59A7"/>
        <path transform="translate(99,145)" d="m0 0 2 1v40l-2 5-28 16-12 7v-3l14-25 14-24 8-14z" fill="#054397"/>
        <path transform="translate(368,391)" d="m0 0 4 1 1 2v54l-15 9-4 2v-56l-2-1v-2z" fill="#1E59A7"/>
        <path transform="translate(168,444)" d="m0 0 12 6 6 4v55l-2 3-5-1-14-8 2-2 1-8z" fill="#1E59A7"/>
        <path transform="translate(512,383)" d="m0 0 1 2-13 23-14 24-10 17-1-3v-38l-4-1 27-16z" fill="#02A7EA"/>
        <path transform="translate(1917,456)" d="m0 0h9l7 10 8 13 1-23h8v37h-9l-13-21-2-3-1 23-1 1h-6l-1-1z"
              fill="#1454A8"/>
        <path transform="translate(1144,456)" d="m0 0h9l14 22 1 2 1-24h8v36l-1 1h-8l-6-9-9-15-1 23-1 1h-7z"
              fill="#1454A8"/>
        <path transform="translate(733,456)" d="m0 0h9l11 17 4 6 1-23h8v36l-1 1h-8l-14-22-1-2-1 23-1 1h-6l-1-1z"
              fill="#1454A8"/>
        <path transform="translate(78,219)" d="m0 0h4l1 2v191l-1 3-4-2-2-5h2v-187l-2-1z" fill="#134CA3"/>
        <path transform="translate(247,62)" d="m0 0h48l2 1 1 3v20l-1 3-6-1-27-15-17-10z" fill="#134CA3"/>
        <path transform="translate(1395,456)" d="m0 0h9l11 18 4 6 1-24h7v37h-8l-4-5-12-19-1 24h-7l-1-2z"
              fill="#144FA5"/>
        <path transform="translate(694,455)"
              d="m0 0 10 2 7 6 3 10-2 10-4 6-8 4h-10l-8-4-4-5-2-6v-8l3-7 5-5 4-2zm-1 7-6 3-3 4v10l5 6 2 1h7l5-3 3-5v-7l-3-6-7-3z"
              fill="#1451A6"/>
        <path transform="translate(1668,455)"
              d="m0 0 10 2 7 6 3 8v7l-3 7-4 5-7 3h-10l-8-4-4-5-2-7 1-10 4-6 5-4zm0 7-7 3-3 5v8l3 5 5 3h7l6-5 1-2v-9l-4-6-5-2z"
              fill="#1452A6"/>
        <path transform="translate(1878,455)"
              d="m0 0 10 2 5 3 4 7 1 4v7l-3 8-6 5-5 2h-10l-8-4-5-8-1-10 3-8 7-6zm0 7-7 3-3 5v8l3 5 5 3h7l6-5 1-2v-9l-3-5-6-3z"
              fill="#1451A6"/>
        <path transform="translate(1105,455)"
              d="m0 0 10 2 6 5 3 6v13l-5 8-5 3-4 1h-9l-8-4-4-5-2-5v-10l4-8 8-5zm-1 7-6 3-3 4v10l3 5 4 2h7l5-3 3-5v-7l-3-6-7-3z"
              fill="#1451A6"/>
        <path transform="translate(1225,456)"
              d="m0 0h16l5 3 2 2v9l-3 4 4 2 2 3v7l-2 4-8 3h-16l-1-2zm7 6v9h7l2-2v-5l-3-2zm0 15v9h9l3-3-1-5-1-1z"
              fill="#1451A6"/>
        <path transform="translate(281,508)" d="m0 0 14 7 24 14 8 5v1h-76v-1l30-1z" fill="#069ADE"/>
        <path transform="translate(873,456)"
              d="m0 0h17l5 3 3 6-1 6-5 5v2l8 12v3h-8l-10-16-2-1v17h-7zm7 6v9h8l2-2v-5l-3-2z" fill="#1450A5"/>
        <path transform="translate(1744,456)" d="m0 0h7l1 1 1 26 2 2h7l2-3 1-26h8v26l-3 7-4 3-3 1h-10l-6-4-3-5z"
              fill="#1453A7"/>
        <path transform="translate(918,456)" d="m0 0h8l1 27 2 2h7l2-2 1-27h8v27l-3 6-4 3-3 1h-9l-6-3-3-4-1-3z"
              fill="#1454A8"/>
        <path transform="translate(641,455)"
              d="m0 0 11 2 6 5 1 5-6 2-5-5-7-1-6 3-3 7 2 9 5 3h7l5-3 3-3 6 3-3 5-5 4-5 2h-10l-8-5-4-5-1-3v-12l5-8 7-4z"
              fill="#1452A6"/>
        <path transform="translate(983,455)"
              d="m0 0 8 1 7 4 3 4v3l-7 2-5-5-6-1-7 2-2 6 1 9 3 4 3 1h7l4-2 2-3 7 1-1 5-6 5-5 2h-10l-8-4-4-6-1-3v-12l3-6 6-5z"
              fill="#1452A7"/>
        <path transform="translate(1981,455)"
              d="m0 0 9 1 6 4 1 5-7 2-1-4h-9l-1 4 2 2 12 4 4 4 1 8-4 6-5 2h-10l-8-5-2-6 8-1 5 5h7v-5l-4-3-11-4-3-3-1-7 3-5 4-3z"
              fill="#1453A7"/>
        <path transform="translate(1546,455)"
              d="m0 0 10 2 5 5 1 3-7 2-3-4h-8l-1 4 5 3 9 3 5 6v6l-4 6-5 2h-9l-8-4-3-5v-2l8-1 5 5h7v-7l-11-3-6-4-2-7 2-5 5-4z"
              fill="#1452A7"/>
        <path transform="translate(295,62)" d="m0 0h19l1 3v32l-1 3-6-2-14-8 3-1v-26z" fill="#1E59A7"/>
        <path transform="translate(1500,455)"
              d="m0 0 9 1 6 5 1 4-7 2-3-4h-8v5l13 5 5 5 1 5-3 7-6 3h-10l-6-3-4-5v-3l8-1 2 4 7 1 3-2-1-4-12-5-5-4-1-2v-6l3-5z"
              fill="#1452A7"/>
        <path transform="translate(797,455)"
              d="m0 0 9 1 6 5 1 4-7 2-3-4h-8v5l13 5 5 5v9l-4 4-4 2h-10l-6-3-4-5v-3l8-1 2 4 7 1 3-3-2-4-13-5-4-5v-6l3-5z"
              fill="#1452A7"/>
        <path transform="translate(1617,455)"
              d="m0 0 9 1 6 5 1 4-7 2-3-4h-8l-1 3 3 3 13 5 3 4v8l-4 5-5 2h-9l-6-3-4-5v-3l8-1 2 4 7 1 2-1v-5l-12-5-4-2-2-3v-8l5-5z"
              fill="#1452A6"/>
        <path transform="translate(1329,455)"
              d="m0 0 9 1 6 5 1 4-7 2-3-4h-8v5l13 5 5 5v9l-6 5-3 1h-9l-6-3-4-5v-3l8-1 2 4 7 1 3-3-2-4-13-5-4-5 1-9 6-4z"
              fill="#1452A7"/>
        <path transform="translate(1270,456)" d="m0 0h7l1 25 1 3 2 1h8l1-4 1-25h7v29l-6 7-3 1h-10l-7-4-2-4z"
              fill="#144EA4"/>
        <path transform="translate(1449,456)" d="m0 0h21v7h-13v8h12v6h-12v9h13v7h-20l-1-1z" fill="#1453A7"/>
        <path transform="translate(324,416)" d="m0 0h3l1 2v26l-1 2-5-1-22-13-1-2z" fill="#064497"/>
        <path transform="translate(1017,456)" d="m0 0h25v6l-1 1h-8v29l-1 1h-6l-1-1v-29h-8z" fill="#1455A9"/>
        <path transform="translate(829,456)" d="m0 0h25v7h-8v29l-1 1h-6l-1-1v-29h-8l-1-1z" fill="#1455A9"/>
        <path transform="translate(166,244)" d="m0 0h2v200l-2-3-1-194-2-1z" fill="#176DB7"/>
        <path transform="translate(1790,456)" d="m0 0h25v7h-9v30h-7v-30h-8l-1-1z" fill="#1551A6"/>
        <path transform="translate(247,150)" d="m0 0 15 8 12 7-4 4-21 12-1-3v-25z" fill="#02A7EA"/>
        <path transform="translate(1707,456)" d="m0 0h8v30h11v7h-18l-1-1z" fill="#1456A9"/>
        <path transform="translate(143,258)" d="m0 0h3l1 2v227l-1 3h-2l1-5v-217z" fill="#054195"/>
        <path transform="translate(1060,456)" d="m0 0h8v36l-1 1h-7z" fill="#1455A8"/>
        <path transform="translate(1833,456)" d="m0 0h8v36l-1 1h-6l-1-1z" fill="#1457AA"/>
        <path transform="translate(1365,456)" d="m0 0h7l1 1v35l-1 1h-6l-1-1z" fill="#1456A9"/>
        <path transform="translate(300,519)" d="m0 0 5 2 21 12 1 2h-76v-1l49-1 3-3-1-8z" fill="#02A7EA"/>
        <path transform="translate(79,219)" d="m0 0h3l1 2v191l-1 3-3-1 1-5 1-1v-184z" fill="#054195"/>
        <path transform="translate(247,62)" d="m0 0h24l2 5-1 7-4 1-21-12z" fill="#064497"/>
        <path transform="translate(105,134)" d="m0 0 2 2v50l-4 1 1-4v-42l-2-2v-3z" fill="#054195"/>
        <path transform="translate(227,403)" d="m0 0h2l2 3v53l-1 3h-5v-2l3-3v-49z" fill="#054195"/>
        <path transform="translate(327,414)" d="m0 0 4 4v26l-2 4-3-1 1-3v-28l-2-1z" fill="#134EA4"/>
        <path transform="translate(271,62)" d="m0 0 3 1 1 2v9l-2 3-3-1 2-9z" fill="#134FA5"/>
        <path transform="translate(229,453)" d="m0 0h2l-1 9h-5v-2l3-3z" fill="#054396"/>
      </svg>
  );
};

export default Logo;
